import React, { useEffect, useState } from 'react'
import Icon from './icons'

interface NumericStepperProps {
    min?: number
    max?: number
    step?: number
    defaultValue?: number
    onChange: (value: number) => void
}
const NumericStepper = ({ min = 0, max = 0.5, step = 0.01, defaultValue = 0, onChange }: NumericStepperProps) => {
    const [value, setValue] = useState<number>(defaultValue)

    const handleIncrement = () => {
        setValue((prev) => {
            return Math.min(max, Number((Number(prev) + step).toFixed(3)))
        })
    }

    const handleDecrement = () => {
        setValue((prev) => Math.max(min, Number((Number(prev) - step).toFixed(3))))
    }

    const handleChange = (e: any) => {
        const val = Number.parseFloat(e.target.value)
        if (!Number.isNaN(val) && val >= min && val <= max) {
            setValue(Number(val.toFixed(3)))
        }
    }

    useEffect(() => {
        onChange(value)
    }, [value])

    return (
        <div className="flex items-center border border-gray-300 rounded overflow-hidden bg-white shadow-sm">
            <div className="pl-1">
                <input type="number" step={step} min={min} max={max} value={value} onChange={handleChange} className="flex-1 border-0 focus:outline-none focus:ring-0 text-[1.042rem] disabled:bg-gray-100 disabled:cursor-not-allowed" />
            </div>

            <button type="button" onClick={handleDecrement} disabled={value <= min} className="flex items-center justify-center w-6 h-7 bg-gray-50 hover:bg-gray-100 disabled:bg-gray-200 disabled:cursor-not-allowed transition-colors duration-150">
                <Icon name="minus" size="1rem" color="#000" />
            </button>
            <div className="border-l border-gray-300 h-6"></div>
            <button type="button" onClick={handleIncrement} disabled={value >= max} className="flex items-center justify-center w-6 h-7 bg-gray-50 hover:bg-gray-100 disabled:bg-gray-200 disabled:cursor-not-allowed transition-colors duration-150">
                <Icon name="plus" size="1rem" color="#000" />
            </button>
        </div>
    )
}

export default NumericStepper
